module.exports = __webpack_public_path__ + "img/success_check.01d44398.gif";